export default [
  {
    path: '/admin/defines/team_types',
    name: 'TeamTypes',
    component: () => import('@/views/Admin/Defines/TeamTypes/Index.vue'),
    meta: {
      pageTitle: 'Başlık',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/team_types/add',
    name: 'TeamTypeAdd',
    component: () => import('@/views/Admin/Defines/TeamTypes/Add.vue'),
    meta: {
      pageTitle: 'Başlık',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/team_types',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/team_types/edit/:id',
    name: 'TeamTypeEdit',
    component: () => import('@/views/Admin/Defines/TeamTypes/Edit.vue'),
    meta: {
      pageTitle: 'Başlık',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/team_types',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
